import { useMemo, useReducer } from "react";
import type { Coordinates } from "./DrawingProvider.types";
import DrawingStoreContext from "./contexts/DrawingStoreContext";
import DrawingActionsContext from "./contexts/DrawingActionsContext";
import drawingReducer, { drawingReducerActions, initialState } from "./drawingReducer";

interface DrawingProviderProps {
  children?: React.ReactNode;
}

function DrawingProvider(props: DrawingProviderProps) {
  const [state, dispatch] = useReducer(drawingReducer, initialState);

  const actions = useMemo(() => {
    return {
      handleSetCoordinates: (payload: Coordinates[]) => {
        dispatch({ type: drawingReducerActions.SET_COORDINATES, payload });
      },
      handleClearCoordinates: () => {
        dispatch({ type: drawingReducerActions.CLEAR_COORDINATES });
      },
    };
  }, []);

  return (
    <DrawingActionsContext.Provider value={actions}>
      <DrawingStoreContext.Provider value={state}>{props.children}</DrawingStoreContext.Provider>
    </DrawingActionsContext.Provider>
  );
}

export default DrawingProvider;
